import API_ENDPOINTS from '../../constants/api-endpoints'

const urlGenerator = {
    dimensions: () => API_ENDPOINTS.dimensions,
    durations: () => API_ENDPOINTS.durations,
    hours: () => API_ENDPOINTS.hours,
    interests: () => API_ENDPOINTS.interests,
    locations: () => API_ENDPOINTS.locations,
    postUser: () => API_ENDPOINTS.postUser,
    getUsers: (offset = 0, limit = 0, roleCodes = '') => API_ENDPOINTS.getUsers
        .replace(':offset', offset)
        .replace(':limit', limit)
        .replace(':roleCodes', roleCodes),
    getUser: (userId) => API_ENDPOINTS.getUser.replace(':userId', userId),
    getUserClasses: (userId) => API_ENDPOINTS.getUserClasses.replace(':userId', userId),
    getUserDroppedClasses: (userId) => API_ENDPOINTS.getUserDroppedClasses.replace(':userId', userId),
    getUserGoals: (userId) => API_ENDPOINTS.getUserGoals.replace(':userId', userId),
    getCourses: (offset = 0, limit = 0) => API_ENDPOINTS.getCourses
        .replace(':offset', offset)
        .replace(':limit', limit),
    course: (courseId) => API_ENDPOINTS.course.replace(':courseId', courseId),
    courses: () => API_ENDPOINTS.courses,
    learningResource: (resourceId) => API_ENDPOINTS.learningResource.replace(':resourceId', resourceId),
    learningResources: () => API_ENDPOINTS.learningResources,
    users: () => API_ENDPOINTS.users,
    user: (userId) => API_ENDPOINTS.user.replace(':userId', userId),
    userCourseEnrollment: (userId, courseId) => API_ENDPOINTS.userCourseEnrollment.replace(':userId', userId).replace(':courseId', courseId),
    userCourses: (userId) => API_ENDPOINTS.userCourses.replace(':userId', userId),
    messages: () => API_ENDPOINTS.messages,
    message: (messageId) => API_ENDPOINTS.message.replace(':messageId', messageId),
    requirements: () => API_ENDPOINTS.requirements,
    userGoals: (userId) => API_ENDPOINTS.userGoals.replace(':userId', userId),
    userGoal: (goalId) => API_ENDPOINTS.userGoal.replace(':goalId', goalId),
    reflectionPrompts: () => API_ENDPOINTS.reflectionPrompts,
    reflectionPrompt: (promptId) => API_ENDPOINTS.reflectionPrompt.replace(':promptId', promptId),
    userReflections: (userId) => API_ENDPOINTS.userReflections.replace(':userId', userId),
    userReflection: (userId, promptId) => API_ENDPOINTS.userReflection.replace(':userId', userId).replace(':promptId', promptId),
    userInterests: (userId) => API_ENDPOINTS.userInterests.replace(':userId', userId),
    systemSettings: () => API_ENDPOINTS.systemSettings,
    systemSetting: (settingId) => API_ENDPOINTS.systemSetting.replace(':settingId', settingId),
    surveys: () => API_ENDPOINTS.surveys,
    survey: (surveyId) => API_ENDPOINTS.survey.replace(':surveyId', surveyId),
    userCourseRatings: (userId) => API_ENDPOINTS.userCourseRatings.replace(':userId', userId),
    userCourseRating: (userId, ratingId) => API_ENDPOINTS.userCourseRating.replace(':userId', userId).replace(':ratingId', ratingId),
    userFacilitatorRatings: (userId) => API_ENDPOINTS.userFacilitatorRatings.replace(':userId', userId),
    userFacilitatorRating: (userId, ratingId) => API_ENDPOINTS.userFacilitatorRating.replace(':userId', userId).replace(':ratingId', ratingId),
}

export default urlGenerator